var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[(_vm.editingAllowed)?_c('Editor'):_vm._e(),_c('PageHeader'),_c('BannerNotice'),_c('Banner'),_c('Bar',{staticClass:"hidden-xs"}),_c('SectionAbout'),_c('SectionPanels'),_c('SectionTabs')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }